<div class="survey-dialog">
  <div class="input">
    <label for="numberOfUsers">Number of Winners:</label>
    <input type="number" id="numberOfUsers" name="numberOfUsers" min="1" max="{{data.correctAnswers}}" [(ngModel)]="numberOfUsers" (ngModelChange)="updateNumberOfUsers()">
  </div>

  <button type="submit" (click)="onSubmit()">Submit</button>

</div>
